import axios from "axios";
import config from "../config/config";

const handleError = (err) => {
  if (err?.response?.status === 401) {
    window.location.href = `/auth/sign-in?returnURL=${window.location.pathname}`;
  } else if (err?.response?.status === 404) {
    window.location.href = "/error/404";
  } else if (err?.response?.status === 400 || err?.response?.status === 422) {
    throw err;
  } else {
    window.location.href = "/error/500";
  }
};

export const settingsApi = {
  getSettings: (data) => {
    return axios(data.id ? `/api/settings/${data.id}` : `/api/settings`, {
      baseURL: config.apiURL,
      withCredentials: true,
      method: "get",
    })
      .then((result) => result.data)
      .catch((err) => handleError(err));
  },
  loadOldStatements: ({ statementsYear, statementsQuarter }) => {
    return axios(
      `/api/aws/load-old-statements?year=${statementsYear}&quarter=${statementsQuarter}`,
      {
        baseURL: config.apiURL,
        withCredentials: true,
        method: "get",
        timeout: 300000,
      }
    )
      .then((result) => result.data)
      .catch((err) => handleError(err));
  },
  loadOldTaxDocuments: () => {
    return axios(`/api/aws/load-old-tax-documents`, {
      baseURL: config.apiURL,
      withCredentials: true,
      method: "get",
      timeout: 300000,
    })
      .then((result) => result.data)
      .catch((err) => handleError(err));
  },
  updateSettings: (data) => {
    return axios(`/api/settings/${data.id}`, {
      baseURL: config.apiURL,
      withCredentials: true,
      method: "put",
      data,
    })
      .then((result) => result.data)
      .catch((err) => handleError(err));
  },
  postDistributionsSheet: ({ type, jsonSheet, socketToken }) => {
    const form_data = new FormData();
    form_data.append("jsonSheet", jsonSheet);
    form_data.append("socketToken", socketToken);
    return axios(`/api/distributions/load-${type}`, {
      baseURL: config.apiURL,
      withCredentials: true,
      method: "post",
      data: form_data,
    })
      .then((result) => result.data)
      .catch((err) => err);
  },
  sendTestEmail: (data) => {
    const form_data = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      form_data.append(key, value);
    });
    return axios(`/api/aws/send-test-email`, {
      baseURL: config.apiURL,
      withCredentials: true,
      method: "post",
      data: form_data,
    })
      .then((result) => result.data)
      .catch((err) => handleError(err));
  },
};
